import React from "react";
import {
  BrowserRouter as Router,
  Link,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Nav from "./components/Nav";
import Seo from "./components/Seo";
import Footer from "./components/Footer";
import FloatingContactButtons from "./components/FloatingContactButtons";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Products from "./pages/Products";
import About from "./pages/About";
import Contact from "./pages/Contact";
import SearchResults from "./pages/SearchResults";
import { pageMeta } from "./data/seoData";
import routeKey from "./routeKey";

const NotFound = () => (
  <>
    <Seo {...pageMeta.notFound} />
    <header className="phero">
      <div className="phero__glow" />
      <div className="phero__grid" />
      <div className="shell phero__inner">
        <p className="eyebrow eyebrow--dark">Error 404</p>
        <h1 className="phero__title">This page is not in the catalogue.</h1>
        <p className="phero__lead">
          The link may be out of date. Everything we stock is one click away.
        </p>
        <div style={{ display: "flex", gap: "0.6rem", flexWrap: "wrap", marginTop: "2rem" }}>
          <Link to="/" className="btn btn--accent">
            Back to home
            <span className="btn__arrow" aria-hidden="true">→</span>
          </Link>
          <Link to="/products" className="btn btn--ghost-light">
            Browse products
          </Link>
        </div>
      </div>
    </header>
  </>
);

/*
 * Keyed on the page so each route fades in on mount. Product detail lives at
 * /products/:slug but is the catalogue with its drawer open, so it shares the
 * catalogue's key instead of remounting and replaying the fade.
 */
const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <main className="app__main route-fade" key={routeKey(location.pathname)}>
      <Routes location={location}>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:slug" element={<Products />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </main>
  );
};

const App = () => (
  <Router>
    <ScrollToTop />
    <div className="app">
      <Nav />
      <AnimatedRoutes />
      <Footer />
      <FloatingContactButtons />
    </div>
  </Router>
);

export default App;
